import * as React from 'react'
import styled from 'styled-components'

import { theme } from '@app/utils/theme'

interface InfoTextContainerProps {
  maxWidth?: string
}

const InfoTextContainer = styled.div<InfoTextContainerProps>`
  font-size: 0.875em;
  color: ${theme.colors.gray};
  margin-bottom: 0.5em;
  max-width: ${({ maxWidth }) => maxWidth || '100%'};
`

interface InfoTextProps {
  content: React.ReactNode
  maxWidth?: string
}

export const InfoText = ({ content, maxWidth }: InfoTextProps) => {
  return <InfoTextContainer maxWidth={maxWidth}>{content}</InfoTextContainer>
}
